// @ts-nocheck
// Generated by tools/client-contract.mjs; Foundation contract SHA-256 35d9836b9bfa444a792da4bdf46b7e131ba58927cacbdf9a920cc0d5708d454f.
export default {
  "listOrganizations": {
    "capability": "identity.organizations:read",
    "method": "get",
    "title": "List organisations",
    "ceiling": 3
  },
  "createOrganization": {
    "capability": "identity.organizations:create",
    "method": "post",
    "title": "Create an organisation",
    "ceiling": 1
  },
  "updateOrganization": {
    "capability": "identity.organizations:update",
    "method": "patch",
    "title": "Update organization",
    "ceiling": 1
  },
  "getOrganization": {
    "capability": "identity.organizations:read",
    "method": "get",
    "title": "Read an organisation",
    "ceiling": 3
  },
  "listInvitations": {
    "capability": "identity.invitations:read",
    "method": "get",
    "title": "List invitations",
    "ceiling": 3
  },
  "createInvitation": {
    "capability": "identity.invitations:create",
    "method": "post",
    "title": "Invite a person",
    "ceiling": 1
  },
  "revokeInvitation": {
    "capability": "identity.invitations:revoke",
    "method": "post",
    "title": "Revoke an invitation",
    "ceiling": 3
  },
  "listCapabilities": {
    "capability": "identity.roles:read",
    "method": "get",
    "title": "List the capability catalogue",
    "ceiling": 3
  },
  "listRoles": {
    "capability": "identity.roles:read",
    "method": "get",
    "title": "List roles",
    "ceiling": 3
  },
  "createRole": {
    "capability": "identity.roles:create",
    "method": "post",
    "title": "Create a role",
    "ceiling": 1
  },
  "getRole": {
    "capability": "identity.roles:read",
    "method": "get",
    "title": "Read a role",
    "ceiling": 3
  },
  "updateRole": {
    "capability": "identity.roles:update",
    "method": "patch",
    "title": "Change a role",
    "ceiling": 1
  },
  "deleteRole": {
    "capability": "identity.roles:delete",
    "method": "delete",
    "title": "Delete a role",
    "ceiling": 1
  },
  "listMemberships": {
    "capability": "identity.memberships:read",
    "method": "get",
    "title": "List members",
    "ceiling": 3
  },
  "getMembership": {
    "capability": "identity.memberships:read",
    "method": "get",
    "title": "Read a membership",
    "ceiling": 3
  },
  "updateMembership": {
    "capability": "identity.memberships:update",
    "method": "patch",
    "title": "Change a member's roles or suspend them",
    "ceiling": 1
  },
  "deleteMembership": {
    "capability": "identity.memberships:delete",
    "method": "delete",
    "title": "Remove a member",
    "ceiling": 1
  },
  "listClients": {
    "capability": "developer.clients:read",
    "method": "get",
    "title": "List registered clients",
    "ceiling": 3
  },
  "createClient": {
    "capability": "developer.clients:create",
    "method": "post",
    "title": "Register an OAuth client",
    "ceiling": 1
  },
  "revokeClient": {
    "capability": "developer.clients:revoke",
    "method": "post",
    "title": "Revoke a service client",
    "ceiling": 2
  },
  "listWebhookEndpoints": {
    "capability": "developer.webhook_endpoints:read",
    "method": "get",
    "title": "List webhook endpoints",
    "ceiling": 3
  },
  "createWebhookEndpoint": {
    "capability": "developer.webhook_endpoints:create",
    "method": "post",
    "title": "Register a webhook endpoint",
    "ceiling": 1
  },
  "sendTestEvent": {
    "capability": "developer.webhook_endpoints:test",
    "method": "post",
    "title": "Send a signed test event",
    "ceiling": 3
  },
  "listGrants": {
    "capability": "identity.grants:read",
    "method": "get",
    "title": "List grants this organisation has given",
    "ceiling": 3
  },
  "revokeGrant": {
    "capability": "identity.grants:revoke",
    "method": "post",
    "title": "Revoke a grant",
    "ceiling": 2
  },
  "getMe": {
    "capability": "identity.self:read",
    "method": "get",
    "title": "Read me and my organisations",
    "ceiling": 3
  },
  "startPasskeyRegistration": {
    "capability": "identity.self:manage",
    "method": "post",
    "title": "Start adding a passkey",
    "ceiling": "human"
  },
  "completePasskeyRegistration": {
    "capability": "identity.self:manage",
    "method": "post",
    "title": "Finish adding a passkey",
    "ceiling": "human"
  },
  "listPasskeys": {
    "capability": "identity.self:read",
    "method": "get",
    "title": "List my passkeys",
    "ceiling": 3
  },
  "getPasskey": {
    "capability": "identity.self:read",
    "method": "get",
    "title": "Read one of my passkeys",
    "ceiling": 3
  },
  "updatePasskey": {
    "capability": "identity.self:manage",
    "method": "patch",
    "title": "Rename a passkey",
    "ceiling": "human"
  },
  "deletePasskey": {
    "capability": "identity.self:manage",
    "method": "delete",
    "title": "Delete a passkey",
    "ceiling": "human"
  },
  "revokeMySessions": {
    "capability": "identity.self:manage",
    "method": "delete",
    "title": "Sign me out everywhere on this client",
    "ceiling": "human"
  },
  "listSessions": {
    "capability": "identity.self:read",
    "method": "get",
    "title": "List my sessions",
    "ceiling": 3
  },
  "revokeSession": {
    "capability": "identity.self:manage",
    "method": "post",
    "title": "End a session",
    "ceiling": "human"
  },
  "leaveOrganization": {
    "capability": "identity.self:manage",
    "method": "delete",
    "title": "Leave an organisation",
    "ceiling": "human"
  },
  "deactivateOrganization": {
    "capability": "identity.organizations:deactivate",
    "method": "post",
    "title": "Suspend an organisation",
    "ceiling": 1
  },
  "reactivateOrganization": {
    "capability": "identity.organizations:reactivate",
    "method": "post",
    "title": "Restore an organisation",
    "ceiling": "human"
  },
  "resendInvitation": {
    "capability": "identity.invitations:create",
    "method": "post",
    "title": "Resend an invitation",
    "ceiling": 1
  },
  "issueRecovery": {
    "capability": "identity.memberships:recover",
    "method": "post",
    "title": "Help a member who lost every passkey",
    "ceiling": "human"
  },
  "listEvents": {
    "capability": "developer.events:read",
    "method": "get",
    "title": "List the organisation's events",
    "ceiling": 3
  },
  "getWebhookEndpoint": {
    "capability": "developer.webhook_endpoints:read",
    "method": "get",
    "title": "Read a webhook endpoint",
    "ceiling": 3
  },
  "updateWebhookEndpoint": {
    "capability": "developer.webhook_endpoints:update",
    "method": "patch",
    "title": "Change a webhook endpoint",
    "ceiling": 2
  },
  "deleteWebhookEndpoint": {
    "capability": "developer.webhook_endpoints:delete",
    "method": "delete",
    "title": "Delete a webhook endpoint",
    "ceiling": 1
  },
  "rotateWebhookSecret": {
    "capability": "developer.webhook_endpoints:update",
    "method": "post",
    "title": "Rotate the endpoint's HMAC secret",
    "ceiling": 2
  },
  "listWebhookDeliveries": {
    "capability": "developer.webhook_endpoints:read",
    "method": "get",
    "title": "List deliveries and their attempts",
    "ceiling": 3
  },
  "redeliverEvent": {
    "capability": "developer.webhook_endpoints:update",
    "method": "post",
    "title": "Re-send one event",
    "ceiling": 3
  },
  "recoverWebhookEndpoint": {
    "capability": "developer.webhook_endpoints:update",
    "method": "post",
    "title": "Re-send every failed delivery since a time",
    "ceiling": 3
  },
  "getAiPolicy": {
    "capability": "agents.ai_policy:read",
    "method": "get",
    "title": "Read the organisation's AI policy",
    "ceiling": 3
  },
  "updateAiPolicy": {
    "capability": "agents.ai_policy:update",
    "method": "patch",
    "title": "Change the organisation's AI policy",
    "ceiling": "human"
  },
  "listAgents": {
    "capability": "agents.agents:read",
    "method": "get",
    "title": "List agents",
    "ceiling": 3
  },
  "createAgent": {
    "capability": "agents.agents:create",
    "method": "post",
    "title": "Create an agent (a role's twin or an external agent)",
    "ceiling": "human"
  },
  "getAgent": {
    "capability": "agents.agents:read",
    "method": "get",
    "title": "Read an agent",
    "ceiling": 3
  },
  "updateAgent": {
    "capability": "agents.agents:update",
    "method": "patch",
    "title": "Change an agent's role, capabilities or levels",
    "ceiling": "human"
  },
  "suspendAllAgents": {
    "capability": "agents.agents:suspend",
    "method": "post",
    "title": "Suspend every agent in the organisation (kill switch)",
    "ceiling": "human"
  },
  "listProposals": {
    "capability": "agents.proposals:read",
    "method": "get",
    "title": "List proposals awaiting or past decision",
    "ceiling": 3
  },
  "getProposal": {
    "capability": "agents.proposals:read",
    "method": "get",
    "title": "Read a proposal with its evidence",
    "ceiling": 3
  },
  "decideProposal": {
    "capability": "agents.proposals:decide",
    "method": "post",
    "title": "Accept",
    "ceiling": "human"
  },
  "listMyGrants": {
    "capability": "identity.self:read",
    "method": "get",
    "title": "List the assistants and clients I have allowed to act for me",
    "ceiling": 3
  },
  "revokeMyGrant": {
    "capability": "identity.self:manage",
    "method": "post",
    "title": "Stop an assistant or client acting for me",
    "ceiling": "human"
  },
  "listMailDomains": {
    "capability": "comms.mail_domains:read",
    "method": "get",
    "title": "List the organisation's email domains",
    "ceiling": 3
  },
  "createMailDomain": {
    "capability": "comms.mail_domains:create",
    "method": "post",
    "title": "Add an email domain",
    "ceiling": 1
  },
  "getMailDomain": {
    "capability": "comms.mail_domains:read",
    "method": "get",
    "title": "Read an email domain and its DNS check results",
    "ceiling": 3
  },
  "deleteMailDomain": {
    "capability": "comms.mail_domains:delete",
    "method": "delete",
    "title": "Remove an email domain",
    "ceiling": 1
  },
  "verifyMailDomain": {
    "capability": "comms.mail_domains:create",
    "method": "post",
    "title": "Check the domain's DNS records now",
    "ceiling": 3
  },
  "listMailboxes": {
    "capability": "comms.mailboxes:read",
    "method": "get",
    "title": "List mailboxes",
    "ceiling": 3
  },
  "createMailbox": {
    "capability": "comms.mailboxes:create",
    "method": "post",
    "title": "Create a mailbox on a verified domain",
    "ceiling": 1
  },
  "updateMailbox": {
    "capability": "comms.mailboxes:update",
    "method": "patch",
    "title": "Change a mailbox's display name or the roles with access",
    "ceiling": 1
  },
  "deleteMailbox": {
    "capability": "comms.mailboxes:delete",
    "method": "delete",
    "title": "Delete a mailbox",
    "ceiling": 1
  },
  "listInboundMessages": {
    "capability": "comms.messages:read",
    "method": "get",
    "title": "List inbound messages",
    "ceiling": 3
  },
  "getInboundMessage": {
    "capability": "comms.messages:read",
    "method": "get",
    "title": "Read an inbound message with its thread and authentication results",
    "ceiling": 3
  },
  "sendMessage": {
    "capability": "comms.messages:send",
    "method": "post",
    "title": "Send a message from a mailbox",
    "ceiling": 1
  },
  "getMessage": {
    "capability": "comms.messages:read",
    "method": "get",
    "title": "Read a sent message and its delivery status",
    "ceiling": 3
  },
  "listReceivingAccounts": {
    "capability": "money.receiving_accounts:read",
    "method": "get",
    "title": "List the accounts the organisation is paid into",
    "ceiling": 3
  },
  "createReceivingAccount": {
    "capability": "money.receiving_accounts:create",
    "method": "post",
    "title": "Record an account the organisation is paid into",
    "ceiling": 2
  },
  "listPaymentRequests": {
    "capability": "money.payment_requests:read",
    "method": "get",
    "title": "List requests to pay, as payee or payer",
    "ceiling": 3
  },
  "createPaymentRequest": {
    "capability": "money.payment_requests:create",
    "method": "post",
    "title": "Ask an organisation or an external payer to pay, in instalments",
    "ceiling": 2
  },
  "getPaymentRequest": {
    "capability": "money.payment_requests:read",
    "method": "get",
    "title": "Read a request to pay",
    "ceiling": 3
  },
  "revisePaymentRequest": {
    "capability": "money.payment_requests:create",
    "method": "post",
    "title": "Revise a request's lines and instalments",
    "ceiling": 2
  },
  "fulfilPaymentRequest": {
    "capability": "money.payment_requests:create",
    "method": "post",
    "title": "Record that what was paid for is delivered",
    "ceiling": 1
  },
  "cancelPaymentRequest": {
    "capability": "money.payment_requests:create",
    "method": "post",
    "title": "Cancel a request, with an optional charge",
    "ceiling": 1
  },
  "settlePaymentRequestExcess": {
    "capability": "money.payment_requests:create",
    "method": "post",
    "title": "Keep money left over as credit, or owe it back as a refund",
    "ceiling": 1
  },
  "createRemittance": {
    "capability": "money.remittances:create",
    "method": "post",
    "title": "Advise the other party that money was sent",
    "ceiling": 2
  },
  "createReceipt": {
    "capability": "money.receipts:create",
    "method": "post",
    "title": "Confirm money received",
    "ceiling": 1
  },
  "reverseReceipt": {
    "capability": "money.receipts:create",
    "method": "post",
    "title": "Reverse a receipt recorded in error",
    "ceiling": 1
  },
  "listLedgerAccounts": {
    "capability": "ledger.journal:read",
    "method": "get",
    "title": "List the organisation's ledger accounts and balances",
    "ceiling": 3
  },
  "listJournalEntries": {
    "capability": "ledger.journal:read",
    "method": "get",
    "title": "List the organisation's journal entries, in chain order",
    "ceiling": 3
  },
  "listFiles": {
    "capability": "files.files:read",
    "method": "get",
    "title": "List the organisation's files",
    "ceiling": 3
  },
  "uploadFile": {
    "capability": "files.files:create",
    "method": "post",
    "title": "Upload a logo, an image or a font",
    "ceiling": 2
  },
  "getFile": {
    "capability": "files.files:read",
    "method": "get",
    "title": "Read a file's record",
    "ceiling": 3
  },
  "deleteFile": {
    "capability": "files.files:delete",
    "method": "delete",
    "title": "Delete a file",
    "ceiling": "human"
  },
  "getFileContent": {
    "capability": "files.files:read",
    "method": "get",
    "title": "Read a file's content",
    "ceiling": 3
  },
  "listBrands": {
    "capability": "branding.brands:read",
    "method": "get",
    "title": "List the organisation's brands",
    "ceiling": 3
  },
  "createBrand": {
    "capability": "branding.brands:create",
    "method": "post",
    "title": "Create a brand from base colours",
    "ceiling": 2
  },
  "deleteBrand": {
    "capability": "branding.brands:delete",
    "method": "delete",
    "title": "Delete a brand",
    "ceiling": "human"
  },
  "getBrand": {
    "capability": "branding.brands:read",
    "method": "get",
    "title": "Read a brand, its draft, the generated tokens and the contrast report",
    "ceiling": 3
  },
  "updateBrand": {
    "capability": "branding.brands:update",
    "method": "patch",
    "title": "Change a brand's draft",
    "ceiling": 2
  },
  "duplicateBrand": {
    "capability": "branding.brands:create",
    "method": "post",
    "title": "Start a new brand from another's draft",
    "ceiling": 2
  },
  "publishBrand": {
    "capability": "branding.brands:publish",
    "method": "post",
    "title": "Publish the draft as the brand's next version",
    "ceiling": 1
  },
  "listBrandVersions": {
    "capability": "branding.brands:read",
    "method": "get",
    "title": "List a brand's published versions",
    "ceiling": 3
  },
  "setDefaultBrand": {
    "capability": "branding.brands:publish",
    "method": "post",
    "title": "Make a published brand the organisation's default",
    "ceiling": 1
  },
  "archiveBrand": {
    "capability": "branding.brands:update",
    "method": "post",
    "title": "Archive a brand",
    "ceiling": 1
  },
  "getBrandDraftTheme": {
    "capability": "branding.brands:read",
    "method": "get",
    "title": "Preview the draft's theme.css",
    "ceiling": 3
  },
  "cleanRichText": {
    "capability": "richtext.content:clean",
    "method": "post",
    "title": "Clean rich text",
    "ceiling": 3
  },
  "getClient": {
    "capability": "developer.clients:read",
    "method": "get",
    "title": "Read a registered client",
    "ceiling": 3
  },
  "updateClient": {
    "capability": "developer.clients:update",
    "method": "patch",
    "title": "Change a registered client",
    "ceiling": 1,
    "narrowing": 2
  },
  "registerMyDevice": {
    "capability": "push.devices:write",
    "method": "put",
    "title": "Register my Android device",
    "ceiling": "human"
  },
  "unregisterMyDevice": {
    "capability": "push.devices:write",
    "method": "delete",
    "title": "Unregister my device",
    "ceiling": "human"
  },
  "listMyDevices": {
    "capability": "push.devices:write",
    "method": "get",
    "title": "List my devices",
    "ceiling": 3
  },
  "sendNotification": {
    "capability": "push.notifications:send",
    "method": "post",
    "title": "Queue a notification",
    "ceiling": 2
  },
  "getNotification": {
    "capability": "push.notifications:read",
    "method": "get",
    "title": "Read notification counts and per-device outcomes",
    "ceiling": 3
  },
  "listReceipts": {
    "capability": "money.payment_requests:read",
    "method": "get",
    "title": "Find a payment in the receiving organisation's receipts",
    "ceiling": 3
  },
  "createCollectionAccount": {
    "capability": "money.collection_accounts:write",
    "method": "post",
    "title": "Connect a receiving bank account for direct settlement",
    "ceiling": 1
  },
  "listCollectionAccounts": {
    "capability": "money.collection_accounts:read",
    "method": "get",
    "title": "List collection accounts",
    "ceiling": 3
  },
  "disconnectCollectionAccount": {
    "capability": "money.collection_accounts:write",
    "method": "post",
    "title": "Deactivate a provider subaccount",
    "ceiling": 1
  },
  "createCollection": {
    "capability": "money.collections:create",
    "method": "post",
    "title": "Ask a payer to pay an open instalment",
    "ceiling": 1
  },
  "getCollection": {
    "capability": "money.collections:read",
    "method": "get",
    "title": "Read a collection and its confirmed receipt",
    "ceiling": 3
  },
  "listCollections": {
    "capability": "money.collections:read",
    "method": "get",
    "title": "List collections",
    "ceiling": 3
  },
  "cancelCollection": {
    "capability": "money.collections:create",
    "method": "post",
    "title": "Cancel a pending collection and release its reservation",
    "ceiling": 1
  },
  "getReceivingAccount": {
    "capability": "money.receiving_accounts:read",
    "method": "get",
    "title": "Get receiving account",
    "ceiling": 3
  },
  "updateReceivingAccount": {
    "capability": "money.receiving_accounts:update",
    "method": "patch",
    "title": "Update receiving account",
    "ceiling": 1
  },
  "archiveReceivingAccount": {
    "capability": "money.receiving_accounts:update",
    "method": "post",
    "title": "Archive receiving account",
    "ceiling": 1
  },
  "restoreReceivingAccount": {
    "capability": "money.receiving_accounts:update",
    "method": "post",
    "title": "Restore receiving account",
    "ceiling": 1
  },
  "getCollectionAccount": {
    "capability": "money.collection_accounts:read",
    "method": "get",
    "title": "Get collection account",
    "ceiling": 3
  },
  "reconnectCollectionAccount": {
    "capability": "money.collection_accounts:write",
    "method": "post",
    "title": "Reconnect collection account",
    "ceiling": 1
  },
  "withdrawRemittance": {
    "capability": "money.remittances:create",
    "method": "post",
    "title": "Withdraw remittance",
    "ceiling": 2
  },
  "listExternalPayers": {
    "capability": "money.external_payers:read",
    "method": "get",
    "title": "List external payers",
    "ceiling": 3
  },
  "getExternalPayer": {
    "capability": "money.external_payers:read",
    "method": "get",
    "title": "Get external payer",
    "ceiling": 3
  },
  "updateExternalPayer": {
    "capability": "money.external_payers:write",
    "method": "patch",
    "title": "Update external payer",
    "ceiling": 2
  },
  "getInvitation": {
    "capability": "identity.invitations:read",
    "method": "get",
    "title": "Get invitation",
    "ceiling": 3
  },
  "updateInvitation": {
    "capability": "identity.invitations:create",
    "method": "patch",
    "title": "Update invitation",
    "ceiling": 1
  },
  "connectInboundMailbox": {
    "capability": "comms.inbound_mailboxes:manage",
    "method": "post",
    "title": "Connect a prepared mailbox for receiving",
    "ceiling": 1
  },
  "listInboundMailboxes": {
    "capability": "comms.inbound_mailboxes:read",
    "method": "get",
    "title": "List receiving mailboxes",
    "ceiling": 3
  },
  "getInboundMailbox": {
    "capability": "comms.inbound_mailboxes:read",
    "method": "get",
    "title": "Read receiving mailbox health",
    "ceiling": 3
  },
  "updateInboundMailbox": {
    "capability": "comms.inbound_mailboxes:manage",
    "method": "patch",
    "title": "Pause or change receiving preferences",
    "ceiling": 1
  },
  "disconnectInboundMailbox": {
    "capability": "comms.inbound_mailboxes:manage",
    "method": "post",
    "title": "Disconnect receiving and keep history",
    "ceiling": 1
  },
  "reconnectInboundMailbox": {
    "capability": "comms.inbound_mailboxes:manage",
    "method": "post",
    "title": "Reconnect receiving and keep history",
    "ceiling": 1
  },
  "getInboundThread": {
    "capability": "comms.messages:read",
    "method": "get",
    "title": "Read a message thread",
    "ceiling": 3
  },
  "getMessageAttachment": {
    "capability": "comms.messages:read",
    "method": "get",
    "title": "Download a permitted message attachment",
    "ceiling": 3
  },
  "labelInboundMessage": {
    "capability": "comms.inbound_messages:update",
    "method": "post",
    "title": "Label a received message",
    "ceiling": 3
  },
  "unlabelInboundMessage": {
    "capability": "comms.inbound_messages:update",
    "method": "post",
    "title": "Unlabel a received message",
    "ceiling": 3
  },
  "archiveInboundMessage": {
    "capability": "comms.inbound_messages:update",
    "method": "post",
    "title": "Archive a received message",
    "ceiling": 3
  },
  "restoreInboundMessage": {
    "capability": "comms.inbound_messages:update",
    "method": "post",
    "title": "Restore a received message",
    "ceiling": 3
  },
  "retryInboundMessage": {
    "capability": "comms.inbound_messages:update",
    "method": "post",
    "title": "Retry reading an unreadable receipt",
    "ceiling": 3
  },
  "purgeInboundMailbox": {
    "capability": "comms.inbound_mailboxes:manage",
    "method": "post",
    "title": "Purge expired receiving history",
    "ceiling": 1
  },
  "getInboundMessageRaw": {
    "capability": "comms.messages:read",
    "method": "get",
    "title": "Download a message's retained original",
    "ceiling": 3
  },
  "listSkippedInboundMessages": {
    "capability": "comms.inbound_mailboxes:read",
    "method": "get",
    "title": "List messages that could not be receipted",
    "ceiling": 3
  },
  "retrySkippedInboundMessage": {
    "capability": "comms.inbound_mailboxes:manage",
    "method": "post",
    "title": "Receive a skipped message again",
    "ceiling": 3
  },
  "createAiExtraction": {
    "capability": "ai.extractions:invoke",
    "method": "post",
    "title": "Extract structured data from text, PDFs and images",
    "ceiling": 2
  },
  "getAiExtraction": {
    "capability": "ai.extractions:read",
    "method": "get",
    "title": "Read an extraction's audit record",
    "ceiling": 3
  },
  "listAiUsage": {
    "capability": "ai.extractions:read",
    "method": "get",
    "title": "AI usage totals per purpose and month, and this month's ceiling",
    "ceiling": 3
  },
  "startEndUserVerification": {
    "capability": "identity.end_users:enroll",
    "method": "post",
    "title": "Email an end user a sign-up or sign-in code",
    "ceiling": "human"
  },
  "checkEndUserVerification": {
    "capability": "identity.end_users:enroll",
    "method": "post",
    "title": "Check an end user's code",
    "ceiling": "human"
  },
  "enrollEndUser": {
    "capability": "identity.end_users:enroll",
    "method": "post",
    "title": "Create an end user's account with this client",
    "ceiling": "human"
  },
  "createEndUserSignIn": {
    "capability": "identity.end_users:enroll",
    "method": "post",
    "title": "Sign an enrolled end user in",
    "ceiling": "human"
  },
  "startEndUserPasskeyAssertion": {
    "capability": "identity.end_users:enroll",
    "method": "post",
    "title": "Start an end user's passkey sign-in",
    "ceiling": "human"
  },
  "deleteEndUser": {
    "capability": "identity.self:manage",
    "method": "delete",
    "title": "Delete my account with this product",
    "ceiling": "human"
  }
} as const;
